;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { BaseButton } from '@qogita/ui/v2/base-button'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import clsx from 'clsx'
import { ComponentProps } from 'react'

export const Popover = PopoverPrimitive.Root

export const PopoverClose = PopoverPrimitive.Close
export const PopoverAnchor = PopoverPrimitive.Anchor

export function PopoverTrigger({
  asChild,
  ...props
}: ComponentProps<typeof BaseButton> & { asChild?: boolean }) {
  return (
    <PopoverPrimitive.Trigger asChild>
      {asChild ? props.children : <BaseButton {...props} />}
    </PopoverPrimitive.Trigger>
  )
}

export function PopoverContent({
  className,
  align = 'start',
  sideOffset = 4,
  collisionPadding = 16,
  ...props
}: ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={clsx(
          'rounded-md border border-gray-300 bg-white',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}
